import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cintas-item-statuses',
  templateUrl: './item-statuses.component.html',
  styleUrls: ['./item-statuses.component.scss']
})
export class ItemStatusesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
